import * as React from "react";
import { CGI_GRADIENT_A, CGI_WHITE } from "../helpers/enums";
import { Box, Icon, Typography } from "@mui/material";

export default function InfoBoxGradient({ text, imageSrc }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: CGI_GRADIENT_A,
        alignItems: "center",
        px: 1,
        py: 1,
        m: 1,
      }}
    >
      <Icon
        sx={{
          height: "auto",
          width: "auto",
          ml: 1,
          mt: 1,
        }}
        onClick={() => navigate("/")}
      >
        <img draggable={false} src={imageSrc} width="35px" />
      </Icon>
      <Typography
        align="center"
        sx={{
          color: CGI_WHITE,
          width: 150,
          lineHeight: 1,
          userSelect: "none",
          py: 0.5,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
